var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.show}},[_c('v-card',{staticClass:"card pa-2",attrs:{"elevation":"2","min-width":"250"}},[(_vm.isNormal)?_c('v-normal-loading'):_vm._e(),(_vm.isPrint)?_c('v-print-loading'):_vm._e(),_c('v-card-text',{staticClass:"card__text pa-2"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }